import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'
import { productByType } from 'utils/products'
import { useSelector } from 'react-redux'
import { productLockedSelector } from 'store/productDevelopment/selectors'

import MoneyUnit from 'components/MoneyUnit'
import ProductQuarters from './ProductQuarters'

const VARIANTS = ['default', 'with-mu']

function Product(props) {
  const { product, variant, className, imgClassName, withMU, quarters } = props
  const isLocked = useSelector(productLockedSelector(product.name))

  const productImg = useMemo(
    () => productByType({ type: product.name, unlock: !isLocked }),
    [product, isLocked]
  )
  const variantClass = variant ? `product--${variant}` : ''
  const muClass = withMU || quarters ? `product--with-mu` : ''

  return (
    <div className={`product ${variantClass} ${muClass} ${className} `}>
      <img src={productImg} alt="product" className={`product__img ${imgClassName}`} />
      {withMU && <MoneyUnit coins={product.cost} className="product__mu" />}
      {quarters && <ProductQuarters quarters={quarters} />}
    </div>
  )
}

export default memo(Product)

Product.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    cost: PropTypes.number
  }).isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  imgClassName: PropTypes.string,
  withMU: PropTypes.bool,
  quarters: PropTypes.shape({
    from: PropTypes.number.isRequired,
    to: PropTypes.number.isRequired,
    ready: PropTypes.bool
  }),
  variant: PropTypes.oneOf(VARIANTS)
}

Product.defaultProps = {
  variant: 'default',
  className: '',
  imgClassName: '',
  withMU: false,
  quarters: null
}
